import React, {Component} from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import CircularProgress from "@material-ui/core/CircularProgress";
import {Link} from "react-router-dom";
import Api from "../../../libraries/api";
import {toast, ToastContainer} from "react-toastify";
import {bindActionCreators} from "redux";
import {RootActions} from "../../../shared/root-action";
import {connect} from "react-redux";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import TicketLists from "../../presentational/ticket-list";
import TransactionList from "../../presentational/transaction-list";
import moment from "moment";
import _ from "lodash";
import UpdateAccount from "./update-account";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Dialog from "@material-ui/core/Dialog";
import ResendOtp from "./resend-otp";

require("dotenv").config();

toast.configure({
    autoClose: 2000,
    draggable: false,
});

function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-auto-tabpanel-${index}`}
            aria-labelledby={`scrollable-auto-tab-${index}`}
            {...other}
        >
            <Box p={3}>{children}</Box>
        </Typography>
    );
}

function a11yProps(index) {
    return {
        id: `scrollable-auto-tab-${index}`,
        "aria-controls": `scrollable-auto-tabpanel-${index}`,
    };
}

class AccountDetail extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            loadingButton: false,
            loadingZipcode: false,
            errors: {},
            search: "",

            showDetail: false,
            showForm: false,
            showFormEdit: false,
            showPassword: false,
            showEdit: false,

            value: 0,
            rows: [],
            rowsActivity: [],

            id: "",
            name: "",
            accountNumber: "",
            balance: "",
            contact: [],
            address: "",
            loginType: "",
            loginSince: "",
            accountCreated: "",

            payments: [],
            vehicles: [],
            transactions: [],
        };

        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        this.__fetchData(false);
    }

    __fetchData = (update) => {
        let id = this.props.match.params.id;

        let route = "/accounts/" + id;
        let route_payment = "/accounts/" + id + "/payments";
        let route_vehicle = "/accounts/" + id + "/vehicles";
        let route_activity = "/accounts/" + id + "/activity";

        Api.get(route)
            .then((resp) => {
                if (resp.data) {
                    let data = resp.data.users;
                    this.setState({
                        id: data.id,
                        name: data.name,
                        accountNumber: data.accountNumber,
                        balance: data.balance,
                        tollTag: data.tollTag,
                        contact: data.contact,
                        address: data.address,
                        loginType: data.loginType,
                        loginSince: data.loginSince,
                        accountCreated: data.accountCreated,
                        accountVersion: data.accountVersion,
                        status: data.status,
                        credits: data.credits
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            });

        Api.get(route_payment)
            .then((resp) => {
                if (resp.data) {
                    this.setState({
                        payments: resp.data.payments,
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            });

        Api.get(route_vehicle)
            .then((resp) => {
                if (resp.data) {
                    console.log("vehicles:", resp.data.vehicles)
                    this.setState({
                        vehicles: resp.data.vehicles,
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            });

        Api.get(route_activity)
            .then((resp) => {
                if (resp.data.activity) {
                    let act = _.orderBy(
                        resp.data.activity,
                        (o) => {
                            return moment(o.Created);
                        },
                        ["desc"]
                    );

                    this.setState({
                        loading: false,
                        rowsActivity: act,
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    handleChange(e, newValue) {
        this.setState({
            value: newValue,
        });
    }

    showMessage = (status, message) => {
        if (status) {
            toast.success(message, {
                position: toast.POSITION.BOTTOM_RIGHT,
            });
        } else {
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT,
            });
        }
    };

    handleChangePage = (event, newPage) => {
        this.setState(
            {
                rows: [],
                currentPage: newPage,
                currentPageTable: newPage,
                loading: true,
            },
            () => {
                this.__fetchData(true);
            }
        );
    };

    handleChangeRowsPerPage = (event) => {
        this.setState(
            {
                perPage: parseInt(event.target.value, 10),
                currentPage: 1,
                loading: true,
            },
            () => {
                this.__fetchData(false);
            }
        );
    };

    render() {
        return (
            <div className="row " >
                <div className="col-12" style={{padding:'0px'}}>
                    <AppBar position="static" color="default">
                        <div className="row align-items-center">
                            <div className="col-md-6">
                                <h2 className="text-title">{this.state.name}</h2>
                            </div>
                            <div className="col-md-3">
                                <p className="mb-0">Flagged: description</p>
                            </div>
                            <div className="col-md-3 text-right">
                                <Link to="/accounts" className="btn btn-blue-trans">
                                    Back to list
                                </Link>
                            </div>
                        </div>

                        <Tabs
                            value={this.state.value}
                            onChange={this.handleChange}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="scrollable"
                            scrollButtons="auto"
                            aria-label="scrollable auto tabs example"
                        >
                            <Tab label="Profile" {...a11yProps(0)} />
                            <Tab label="Vehicle" {...a11yProps(1)} />
                            <Tab label="Payment" {...a11yProps(2)} />
                            <Tab label="Settings" {...a11yProps(3)} />
                            <Tab label="Tickets" {...a11yProps(4)} />
                            <Tab label="Transactions" {...a11yProps(5)} />
                            <Tab label="Activity" {...a11yProps(6)} />
                        </Tabs>
                    </AppBar>

                    <TabPanel value={this.state.value} index={0}>
                        <div >
                            <div className="row" style={{marginBottom:'25px'}}>
                                <div className="col-md-6">
                                    <div className="card" style={{padding:'20px'}}>
                                        <h2 className="text-title-card">Profile Information</h2>
                                        <div className="row" style={{marginTop:'20px'}}>
                                            <label className="col-4 text-grey">Name</label>
                                            <p className=" col-8 text-black-bold">{this.state.name}</p>
                                        </div>
                                        <div className="row" >
                                            <label className="col-4 text-grey">Balance account</label>
                                            <p className="col-8 text-black-bold">${this.state.balance}</p>
                                        </div>
                                        <div className="row" >
                                            <label className="col-4 text-grey">Toll Tag ID</label>
                                            <p className="col-8 text-black-bold">{this.state.tollTag}</p>
                                        </div>
                                        <div className="row ">
                                            <label className="col-4 text-grey">Contact</label>
                                            <div className="col-5 text-black-bold">
                                                {this.state.contact.map((item, index) => {
                                                    return (
                                                        <p key={index} style={{margin:'0px'}}>
                                                            {item}
                                                        </p>
                                                    );
                                                })}
                                            </div>
                                            <button className="col-3 btn-trans">Add contact</button>
                                        </div>
                                        <div className="row" style={{marginTop:'10px'}}>
                                            <label className="col-4 text-grey">Address 1</label>
                                            <p className="col-5 text-black-bold">{this.state.address}</p>
                                            <button className="col-3 btn-trans">Add address</button>
                                        </div>
                                        <hr style={{marginTop:'50px'}}/>
                                        <Fulfillment userId={this.state.accountNumber}/>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="card">
                                        <h2 className="text-title-card">Account Information</h2>
                                        <div style={{marginTop:'20px'}}>
                                            <UpdateAccount 
                                                    accountVersion={this.state.accountVersion}
                                                    accountStatus={this.state.status} credits={this.state.credits}
                                                    userId={this.state.accountNumber}
                                                    accountCreated={this.state.accountCreated}
                                                    accountNumber={this.state.accountNumber}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row" >
                                <div className="col-md-6">
                                    <div className="card" style={{padding:'20px'}}>
                                    <h2 className="text-title-card">Log History</h2>
                                        <div className="row" style={{margintop:'20px'}}>
                                            <label className="col-4 text-grey">Login type</label>
                                            <p className="col-5 text-black-bold">{this.state.loginType}</p>
                                        </div>            
                                        <div className="row">
                                            <label className="col-4 text-grey">Logged in since</label>
                                            <p className="col-5 text-black-bold">{this.state.loginSince}</p>
                                        </div>
                                        <hr />
                                        <div className="row">
                                            <div className="col-6"/>
                                            <button className="btn-trans col-3">Force Logout</button>
                                            <ResendOtp newUser={false} userOtpContact={this.state.contact[0]}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel value={this.state.value} index={1}>
                        <div className="row" style={{marginTop:'-10px'}}>
                            {this.state.vehicles.length ? (
                                this.state.vehicles.map((item, index) => {
                                    return (
                                        <div className="col-md-6" key={index}>
                                            <div  className="card" style={{marginTop:'15px',padding:'10px 20px'}}>
                                                <label className="text-title-card">Vehicle {index + 1}</label>
                                                <p className="pl-2 pl-lg-3">
                                                    <div className="row">
                                                        <div className="column" column-width="auto">
                                                            <img
                                                                src={item.patch}
                                                                alt="Red dot"
                                                                width="200"
                                                                height="70"
                                                                style={{borderRadius:'3px'}}
                                                            />
                                                        </div>
                                                        <div className="column">
                                                            <label className="title">License</label>
                                                            {item.licensePlateNumber} <br/>
                                                            <br/>
                                                            <label className="title">Nick Name</label>
                                                            {item.nickName} <br/>
                                                            <br/>
                                                            <label className="title">Type</label>
                                                            {item.type.charAt(0).toUpperCase() +
                                                            item.type.slice(1)}{" "}
                                                            <br/>
                                                        </div>
                                                        <div className="column">
                                                            <label className="title">State</label>
                                                            {item.licensePlateState} <br/>
                                                            <br/>
                                                            <label className="title">Make</label>
                                                            {item.make.charAt(0).toUpperCase() +
                                                            item.make.slice(1)}{" "}
                                                            <br/>
                                                            <br/>
                                                            <label className="title">Color</label>
                                                            {item.color.charAt(0).toUpperCase() +
                                                            item.color.slice(1)}{" "}
                                                            <br/>
                                                        </div>
                                                    </div>
                                                </p>
                                                <div className="content-center-center" style={{margin:'-20px 0px 15px 0px' }}>
                                                    <img
                                                        src={item.overview}
                                                        alt="Red dot"
                                                        style={{borderRadius:'3px'}}
                                                        height= '50%'
                                                        width= '50%'
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })
                            ) : (
                                <div className="col-md-4" style={{height:window.innerHeight-200}}>
                                    <label className="title">No Vehicle</label>
                                </div>
                            )}
                        </div>
                    </TabPanel>
                    <TabPanel value={this.state.value} index={2}>
                        <div className="row" >
                            {this.state.payments.length ? (
                                <>
                                    {this.state.payments.map((item, index) => {
                                        return (
                                            <div className="col-md-4 card " style={{margin:'10px',padding:'10px 20px'}} key={index}>
                                                <label className="text-title-card">
                                                    {item.paymentType
                                                        ? item.paymentType
                                                        : item.paymentMethodName}
                                                </label>
                                                <p className="pl-2 pl-lg-3">
                                                    {item.card === "" ? "" : "Card Number " + item.card}{" "}
                                                    <br/>
                                                    {item.expires === ""
                                                        ? ""
                                                        : "Expires " + item.expires}{" "}
                                                    <br/>
                                                    {item.billingAddress && (
                                                        <>
                                                            <br/>
                                                            <strong>Billing Address:</strong>
                                                            <br/>
                                                            <span
                                                                dangerouslySetInnerHTML={{
                                                                    __html: item.billingAddress,
                                                                }}
                                                            />
                                                        </>
                                                    )}
                                                </p>
                                                <p className="pl-2 pl-lg-3 text-blue">
                                                    {item.primary === 1 ? "• primary" : ""}
                                                </p>
                                            </div>
                                        );
                                    })}
                                    <div className="col-12" style={{marginTop:'10px'}}>
                                        <button className="btn btn-blue-trans mb-2">
                                            Add payment method
                                        </button>
                                    </div>
                                </>
                            ) : (
                                <div className="col-md-4" style={{height:window.innerHeight-220}}>
                                    <label className="title">No Payment</label>
                                </div>
                            )}
                        </div>
                    </TabPanel>
                    <TabPanel value={this.state.value} index={3}>
                        <div className="row" style={{padding:'0px 10px' }}>
                            <div className="col-md-8 card" style={{padding:'20px'}}>
                                <label className="title">Permissions </label>
                                <div className="row">
                                    <div className="col-4">
                                        <p className="pl-2 pl-lg-3">Comment about</p>
                                    </div>
                                    <div className="col-4">
                                        <p>Denied</p>
                                        <p>Granted</p>
                                    </div>
                                    <div className="col-4 pl-0">
                                        <button className="btn btn-blue-trans mb-2">
                                            Send request
                                        </button>
                                        <button className="btn btn-blue-trans mb-2">
                                            Send request
                                        </button>
                                    </div>
                                </div>
                                <label className="title">Diagnostics</label>
                                <p className="pl-2 pl-lg-3">App version Device etc.</p>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel value={this.state.value} index={4}>
                        <div className="row" >
                            <div className="col-12">
                                <label className="title"></label>
                            </div>
                        </div>
                        <TicketLists user={this.props.match.params.id}/>
                    </TabPanel>
                    <TabPanel value={this.state.value} index={5}>
                        <div className="row" >
                            <div className="col-12" >
                                <label className="title">{/*Transactions*/} </label>
                            </div>
                        </div>
                        <TransactionList user={this.props.match.params.id}/>
                    </TabPanel>
                    <TabPanel value={this.state.value} index={6}>
                        <div className="row" style={{padding:'0px 10px'}} >
                            <div className="col-12 card" style={{padding:'20px'}}>
                                <label className="title">Account activity </label>

                                <div className="table-wrapper">
                                    <Table className="table-list mt-3" size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Event ID</TableCell>
                                                <TableCell>Status</TableCell>
                                                <TableCell>Created</TableCell>
                                                <TableCell>Event Description</TableCell>
                                                <TableCell>By</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {this.state.loading ? (
                                                <TableRow>
                                                    <TableCell
                                                        colSpan={8}
                                                        align="center"
                                                        className="py-5"
                                                    >
                                                        <CircularProgress color="primary"/>
                                                    </TableCell>
                                                </TableRow>
                                            ) : this.state.rowsActivity.length === 0 ? (
                                                <TableRow style={{height: 33 * 20}}>
                                                    <TableCell
                                                        colSpan={8}
                                                        style={{textAlign: "center"}}
                                                    >
                                                        No activity
                                                    </TableCell>
                                                </TableRow>
                                            ) : (
                                                this.state.rowsActivity.map((row, index) => {
                                                    return (
                                                        <TableRow key={index} selected={row.selected}>
                                                            <TableCell style={{color:'#008299'}}>
                                                                {row.EventId === null ? "NA" : row.EventId}
                                                            </TableCell>
                                                            <TableCell>
                                                                {row.Status === null ? "NA" : row.Status}
                                                            </TableCell>
                                                            <TableCell>
                                                                {row.Created === null
                                                                    ? "NA"
                                                                    : moment(row.Created).format(
                                                                        "dddd, MMM D YYYY, k:mm:ss"
                                                                    )}
                                                            </TableCell>
                                                            <TableCell>
                                                                {row.EventDescription === null
                                                                    ? "NA"
                                                                    : row.EventDescription}
                                                            </TableCell>
                                                            <TableCell>
                                                                {row.by === null ? "NA" : row.by}
                                                            </TableCell>
                                                        </TableRow>
                                                    );
                                                })
                                            )}
                                        </TableBody>
                                    </Table>
                                </div>
                            </div>
                        </div>
                    </TabPanel>
                </div>

                <ToastContainer/>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        permission_state: state.permission_state,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(RootActions, dispatch);
};

class Fulfillment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showFulfillment: false,
            hasAnOrder: false,
            userId: '',
            accountNumber: '',
            created: '',
            status: 'Not ordered',
            order: '',
            transponderFee: '',
            name: '',
            email: '',
            address: '',
            stateName: '',
            city: '',
            postalCode: '',
            deliveryProvider: '',
            trackingNumber: '',
            purchaseDetail: [],
            purchaseHistory: []
        }
        this.showDetail = this.showDetail.bind(this);
    }

    showDetail() {
        Api.get('/accounts/' + this.props.userId, true).then(resp => {
            if (resp.data) {
                this.setState({
                    userId: resp.data.users.accountNumber,
                    name: resp.data.users.name,
                    email: (resp.data.users.contact[0]) ? resp.data.users.contact[0] : '',
                    address: resp.data.users.address,
                    stateName: resp.data.users.stateName,
                    city: resp.data.users.city,
                    postalCode: resp.data.users.postalCode,
                    deliveryProvider: resp.data.users.deliveryProvider,
                    trackingNumber: resp.data.users.trackingNumber,
                })
            }
        }).catch(err => {
            console.log(err);
        });
        //Get Purchase Data
        Api.get('/purchases?userId=' + this.props.userId, true).then(resp => {
            //Get Detail
            Api.get('/purchase/detail/' + resp.data.Purchases[0]['id'], true).then(respPurchase => {
                this.setState({
                    purchaseDetail: respPurchase.data.Purchase,
                    purchaseHistory: respPurchase.data.purchaseHistory,
                    hasAnOrder: true
                })
            });
        }).catch(err => {
            console.log(err);
        });
        this.setState({showFulfillment: true})
    }

    handleClose = e => {
        this.setState(prevState => ({
                showFulfillment: false,
            })
        )
    };

    render() {
        let purchase = this.state.purchaseDetail;
        let purchaseHistory = this.state.purchaseHistory;
        if (this.state.hasAnOrder === false) {
            return (
                <div>
                    <div className="row" >
                        <div className="col-9" ></div>
                        <button className="btn-trans col-3" onClick={this.showDetail}>Fulfillment</button>
                    </div>
                    <Dialog
                        maxWidth={'md'}
                        open={this.state.showFulfillment}
                        onClose={this.handleClose}
                        aria-labelledby="form-dialog-title"
                        className="dialog-custom">
                        <DialogTitle id="form-dialog-title">
                            <div className="row align-items-center">
                                <div className="col-md-6">
                                    <span>Order</span>
                                </div>
                            </div>
                            <button onClick={this.handleClose} className="btn-close">
                                <i className="fas fa-times"> </i>
                            </button>
                        </DialogTitle>
                        <DialogContent>
                            The user doesn't has an order.
                        </DialogContent>
                    </Dialog>
                </div>
            )
        }
        if (this.state.hasAnOrder === true) {
            return (
                <div>
                    <button className="btn btn-blue-trans mb-2" onClick={this.showDetail}>Fulfillment</button>
                    <Dialog
                        maxWidth={'xl'}
                        scroll={"body"}
                        open={this.state.showFulfillment}
                        onClose={this.handleClose}
                        aria-labelledby="form-dialog-title"
                        className="dialog-custom">
                        <DialogTitle id="form-dialog-title">
                            <div className="row align-items-center">
                                <div className="col-md-6">
                                    <span>Order</span>
                                </div>
                                <div className="col-md-6">
                                    <p className="mb-0"><label className="title d-inline">Status</label>
                                        {purchase['status'] === 'sent' ?
                                            (<i
                                                className="status text-capitalize"> Shipped</i>) : (<i
                                                className="status text-capitalize"> {purchase['status']}</i>)
                                        }
                                    </p>
                                </div>
                            </div>
                            <button onClick={this.handleClose} className="btn-close">
                                <i className="fas fa-times"> </i>
                            </button>
                        </DialogTitle>
                        <DialogContent>
                            <div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <label className="title">Account number</label>
                                        <p className="pl-2 pl-lg-3">{purchase["userId"]}</p>
                                        <Link to={'/accounts/detail/' + purchase["userId"]}
                                              className="btn btn-blue-trans mb-3">Go
                                            to Account</Link>
                                        <label className="title">Contact and Shipping</label>
                                        <p className="pl-2 pl-lg-3">
                                            {purchase["fullName"]}<br/>
                                            {purchase["address"]}<br/>
                                            {purchase["city"]}, {purchase["stateId"]} {purchase["postalCode"]}<br/>
                                            {purchase["email"]}<br/>
                                        </p>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <label className="title">Request Date</label>
                                                <p className="pl-2 pl-lg-3">{purchase["created"]}</p>
                                            </div>
                                            {purchase['status'] === 'sent' ?
                                                (
                                                    <div className="col-md-6">
                                                        <label className="title">Shipped Date</label>
                                                        <p className="pl-2 pl-lg-3">{purchase["transponderShippedDate"]}</p>
                                                    </div>
                                                ) : ('')
                                            }
                                            {purchase['status'] === 'delivered' ?
                                                (
                                                    <div className="col-md-6">
                                                        <label className="title">Delivered Date</label>
                                                        <p className="pl-2 pl-lg-3">{purchase["createdAt"]}</p>
                                                    </div>
                                                ) : ('')
                                            }

                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <label className="title">Delivery Provider</label>
                                                <p className="pl-2 pl-lg-3">{purchase["provider"]}</p>
                                            </div>
                                            <div className="col-md-6">
                                                <label className="title">Tracking Id</label>
                                                <p className="pl-2 pl-lg-3">{purchase["trackId"]}</p>
                                            </div>
                                            <div className="col-12">
                                                <label className="title"></label>
                                                <p className="pl-2 pl-lg-3"></p>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <label className="title">Toll Tag Id</label>
                                                <p className="pl-2 pl-lg-3">{purchase["transponderShippedId"]}</p>
                                            </div>
                                            <div className="col-md-6">
                                                <label className="title">Toll Tag Fee</label>
                                                <p className="pl-2 pl-lg-3">$0.0</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <label>Shipped History</label>
                                <div className="table-wrapper">
                                    <Table className="table-list mt-3" size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Toll Tag Id</TableCell>
                                                <TableCell>Delivery Provider</TableCell>
                                                <TableCell>Tracking Id</TableCell>
                                                <TableCell>Shipping Date</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {purchaseHistory.map(function (item, i) {
                                                return (
                                                    <TableRow key={"history-shipped" + item.id}>
                                                        <TableCell>{item.transponderId}</TableCell>
                                                        <TableCell>{item.provider}</TableCell>
                                                        <TableCell>{item.trackId}</TableCell>
                                                        <TableCell>{item.transponderShippedDate}</TableCell>
                                                    </TableRow>
                                                )
                                            })}
                                        </TableBody>
                                    </Table>
                                </div>
                            </div>
                        </DialogContent>
                    </Dialog>
                </div>
            )
        }

    }
}


export default connect(mapStateToProps, mapDispatchToProps)(AccountDetail);
